<template>
    <div class="content">
        <p>{{ translate("predefined_notification.following") }}</p>
        <pre class="has-word-wrapping is-small">{{ data.content }}</pre>
    </div>
</template>

<script setup lang="ts">
    import { translate } from "../../Common/translations";
    import type { PaymentReminderNotification } from "../../Api/predefinedNotifications";

    defineProps<{
        data: PaymentReminderNotification;
    }>();
</script>
